import { isEmpty } from 'lodash';
import { view_types } from '../viewTypes';
import { getCookie } from '../../services/cookies';

import setAuthorisationToken from '../../services/setAuthorisationToken';

const initialState = {
  view: view_types.new,
};

const cookieName = 'ftipstate';
let cookieDomain = `path=/;domain=${window.location.host}`;

export const loadState = () => {
  try {
    const storedState = getCookie(cookieName);

    if (storedState === null) {
      return initialState;
    }

    const state = JSON.parse(storedState);
    return isEmpty(state) ? initialState : state;
  } catch (error) {
    console.log(error);
    return initialState;
  }
};

export const saveState = (state) => {
  try {
    // update auth token when state is update not on next refresh
    setAuthorisationToken(state.token);

    // We dont need to keep the state of
    // showSmallBox, showDisabilitySuccess
    // into localstorage
    delete state.showSmallBox;
    delete state.showDisabilitySuccess;
    delete state.seenOverlayers;

    delete state.articleRatings;
    delete state.visits;

    const storedState = JSON.stringify(state);

    if (!process.env.NODE_ENV || process.env.NODE_ENV === 'development') {
      cookieDomain = '';
    }

    document.cookie = `${cookieName}=${storedState};${cookieDomain}`;
  } catch (error) {
    //TODO add error
  }
};
